var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-10 px-4"},[_c('div',{staticClass:"rounded-2xl w-full videocont relative"},[_c('iframe',{staticClass:"w-full h-full absolute top-0 left-0 rounded-2xl",attrs:{"src":"https://www.youtube.com/embed/gaceUrt7xO0","frameborder":"0","title":"PaddyCover Intro"}})])])
}]

export { render, staticRenderFns }